module.exports = __webpack_public_path__ + "static/media/logo-white-no-text.fa81f72b.svg";